  if (!window.vntReadMoreInit) {
    window.vntReadMoreInit = true;
    
    document.addEventListener('click', function(e) {
      // Section Text
      const sectionTextBtn = e.target.closest('.vnt-section-text__read-more');
      if (sectionTextBtn) {
        e.stopPropagation();
        const wrapper = sectionTextBtn.closest('.vnt-section-text--truncatable');
        if (wrapper) {
          const isExpanded = wrapper.classList.toggle('is-expanded');
          sectionTextBtn.querySelector('span').textContent = isExpanded ? 'Lees minder' : 'Lees meer';
        }
        return;
      }

      // Multicolumn
      const multicolumnBtn = e.target.closest('.multicolumn-card__read-more');
      if (multicolumnBtn) {
        e.stopPropagation();
        const wrapper = multicolumnBtn.closest('.multicolumn-card__text--truncatable');
        if (wrapper) {
          const isExpanded = wrapper.classList.toggle('is-expanded');
          multicolumnBtn.querySelector('span').textContent = isExpanded ? 'Lees minder' : 'Lees meer';
        }
        return;
      }
    });
  }